import React from 'react';
export const FooterSection: React.FC = () => {
  return <footer className="bg-[#0F1F0F] text-[#666] text-center py-[35px] px-5 text-[13px] font-sans leading-[2]" data-id="element-99">
      <div className="text-base font-bold text-[#A5D6A7] mb-2 font-serif" data-id="element-100">
        🌿 TIERRA VIVA™
      </div>
      <p data-id="element-101">
        El sistema de bioconstrucción N°1 para el autoconstructor moderno en
        Argentina y Latinoamérica.
      </p>
      <p data-id="element-102">
        Porque construir tu casa natural no debería costarte todos los domingos
        del año.
      </p>

      <hr className="border-none border-t border-[#222] my-5 mx-auto max-w-[400px]" data-id="element-103" />

      <p className="flex justify-center gap-5 flex-wrap" data-id="element-104">
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-105">
          Política de Privacidad
        </a>
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-106">
          Términos y Condiciones
        </a>
        <a href="#" className="text-[#888] no-underline hover:text-[#CCC] transition-colors" data-id="element-107">
          Contacto
        </a>
      </p>

      <p className="mt-2.5 text-[11px] text-[#444] leading-relaxed" data-id="element-108">
        © MEGA PACK TIERRA VIVA™ 2026 — Todos los derechos reservados.
        <br data-id="element-109" />
        Prohibida la reproducción y redistribución sin autorización expresa.
        <br data-id="element-110" />
        Este producto es un pack digital educativo. Los resultados varían según
        la aplicación individual.
      </p>

      <br data-id="element-111" />

      <p className="italic text-green-light" data-id="element-112">
        🌿 "La tierra te espera. El sistema ya está listo."
      </p>
    </footer>;
};